// extracted by mini-css-extract-plugin
export var container = "_fe-1";
export var cornerButtonContainer = "_fe-6";
export var disabled = "_fe-2";
export var dragActive = "_fe-3";
export var fileContainer = "_fe-5";
export var hiddenInput = "_fe-4";
export var widthContainer = "_fe-0";